import { fetcher } from '@commenda/utils';
import type { IUsersLosingAccess } from './types';

export async function fetchUsersLosingAccess(
  serviceRequestId: string,
  agentFirmId: string,
  token?: string
): Promise<IUsersLosingAccess | null> {
  const res = await fetcher(
    `service-request/${serviceRequestId}/subscribed-firms/${agentFirmId}/users-losing-access`,
    { method: 'GET' },
    token
  );
  if (!res.ok) return null;

  return (await res.json()) as IUsersLosingAccess;
}

export async function unsubscribeAgentFirm(
  serviceRequestId: string,
  agentFirmId: string,
  token?: string
): Promise<boolean> {
  const res = await fetcher(
    `service-request/${serviceRequestId}/subscribed-firms/${agentFirmId}`,
    { method: 'DELETE' },
    token
  );

  return res.ok;
}
